<template>
  <!-- eslint-disable -->
    <div style="text-align:left; background-color: #fafbfc;">

        <div class="column-left">
            <SideNav />
        </div>

        <div class="column-right">
            <TopNav />
            <div class="main-container">

                <div v-if="true" class="articulo-principal">
                    <div class="welcome-header">
                        <div class="welcome-icon">
                            <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 3C12.134 3 9 6.134 9 10C9 13.866 12.134 17 16 17C19.866 17 23 13.866 23 10C23 6.134 19.866 3 16 3ZM14 10C14 8.895 14.895 8 16 8C17.105 8 18 8.895 18 10C18 11.105 17.105 12 16 12C14.895 12 14 11.105 14 10Z"
                                    :fill="prestador.admin.assets.colors.primary" />
                                <path
                                    d="M24 19H8C6.895 19 6 19.895 6 21V28C6 29.105 6.895 30 8 30H24C25.105 30 26 29.105 26 28V21C26 19.895 25.105 19 24 19ZM16 24C18.209 24 20 22.209 20 20C20 17.791 18.209 16 16 16C13.791 16 12 17.791 12 20C12 22.209 13.791 24 16 24Z"
                                    :fill="prestador.admin.assets.colors.primary" />
                            </svg>
                        </div>
                        <h1 class="welcome-title">Panel UC en Casa</h1>
                        <p class="welcome-subtitle">Gestión integral de atención domiciliaria</p>
                    </div>

                    <div class="content-card">
                        <div class="card-header">
                            <div class="greeting-section">
                                <h2 class="greeting-title">¡Bienvenido al Centro de Control!
                                    <span class="greeting-emoji">🏠</span>
                                </h2>
                                <p class="greeting-description">
                                    Desde este panel centralizado, gestiona todas las operaciones del servicio UC en
                                    Casa,
                                    optimizando la atención domiciliaria y garantizando la excelencia en cada
                                    intervención.
                                </p>
                            </div>
                        </div>

                        <div class="features-section">
                            <h3 class="features-title">Funcionalidades Principales</h3>

                            <div class="features-grid">
                                <div class="feature-card">
                                    <div class="feature-icon geolocation">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
                                                fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div class="feature-content">
                                        <h4 class="feature-title">Geolocalización en Tiempo Real</h4>
                                        <p class="feature-description">Monitorea la ubicación exacta de los equipos
                                            médicos y profesionales
                                            en terreno. Optimiza rutas y tiempos de respuesta para atención urgente.</p>
                                    </div>
                                </div>

                                <div class="feature-card">
                                    <div class="feature-icon calendar">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
                                                fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div class="feature-content">
                                        <h4 class="feature-title">Calendario Inteligente</h4>
                                        <p class="feature-description">Programa y visualiza todas las atenciones
                                            domiciliarias.
                                            Gestiona disponibilidad de equipos y profesionales con sincronización
                                            automática.</p>
                                    </div>
                                </div>

                                <div class="feature-card">
                                    <div class="feature-icon attention">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM12 5.5L16.5 10H13V14H11V10H7.5L12 5.5Z"
                                                fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div class="feature-content">
                                        <h4 class="feature-title">Visualización de Atenciones</h4>
                                        <p class="feature-description">Accede al historial completo de atenciones
                                            realizadas.
                                            Consulta detalles, observaciones y seguimiento de cada paciente en tiempo
                                            real.</p>
                                    </div>
                                </div>

                                <div class="feature-card">
                                    <div class="feature-icon management">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                                                fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div class="feature-content">
                                        <h4 class="feature-title">Gestión de Tomadores</h4>
                                        <p class="feature-description">Administra el equipo completo de profesionales.
                                            Asigna responsabilidades, gestiona permisos y mantén actualizada la
                                            información del personal.</p>
                                    </div>
                                </div>

                                <div class="feature-card">
                                    <div class="feature-icon analytics">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M3.5 18.49L9 12.99L13 16.99L22 6.92L20.59 5.51L13 13.1L9 9.1L2.09 17.01L3.5 18.49Z"
                                                fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div class="feature-content">
                                        <h4 class="feature-title">Reportes y Métricas</h4>
                                        <p class="feature-description">Genera informes detallados de productividad y
                                            calidad de servicio.
                                            Analiza indicadores clave para la mejora continua del servicio.</p>
                                    </div>
                                </div>

                                <div class="feature-card">
                                    <div class="feature-icon support">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM11 5H13V7H11V5ZM11 9H13V15H11V9Z"
                                                fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div class="feature-content">
                                        <h4 class="feature-title">Soporte Técnico</h4>
                                        <p class="feature-description">¿Necesitas ayuda? Nuestro equipo de soporte está
                                            disponible
                                            para resolver cualquier inconveniente con el sistema.</p>
                                        <a href="https://tally.so/r/mVaK5g" target="_blank"
                                            class="btn-soporte">Contactar Soporte</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="footer-section">
                            <div class="commitment-card">
                                <div class="commitment-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
                                            fill="#10b981" />
                                    </svg>
                                </div>
                                <div class="commitment-content">
                                    <p class="commitment-text">
                                        En ClinicGo, nos dedicamos a brindar atención médica domiciliaria de la más
                                        alta calidad.
                                        Tu gestión es fundamental para garantizar que cada paciente reciba el cuidado
                                        que merece.
                                    </p>
                                    <div class="signature">
                                        <p class="signature-text">Comprometidos con la excelencia,</p>
                                        <p class="signature-team"><strong>Equipo ClinicGo</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
/* eslint-disable */

import { mapGetters, mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';

export default {
    name: 'UcEnCasaPanel',
    props: ['id'],
    components: {
        SideNav,
        Loader,
        TopNav,
    },
    data() {
        return {
            // Datos específicos para UC en Casa
        }
    },
    created() {
        // Inicialización específica para UC en Casa
    },

    methods: {
        ...mapActions(['initialize']),
        // Métodos específicos para UC en Casa
    },
    computed: {
        ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos', 'prestador']),
    },
}
</script>

<style scoped>
/* Variables CSS actualizadas para UC en Casa */
:root {
    --primary-color: #0ea5e9;
    --primary-light: #e0f2fe;
    --secondary-color: #10b981;
    --secondary-light: #d1fae5;
    --accent-color: #8b5cf6;
    --text-primary: #1e293b;
    --text-secondary: #64748b;
    --text-muted: #94a3b8;
    --background-primary: #fafbfc;
    --background-secondary: #ffffff;
    --border-color: #e2e8f0;
    --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    --radius-sm: 6px;
    --radius-md: 8px;
    --radius-lg: 12px;
    --radius-xl: 16px;
}

/* Estilos específicos para UC en Casa */

.btn-soporte {
    display: inline-block;
    background-color: #007BFF;
    color: white;
    padding: 10px 20px;
    border-radius: 6px;
    text-decoration: none;
    font-weight: bold;
    font-size: 0.875rem;
    transition: background-color 0.3s ease;
    margin-top: 10px;
}

.btn-soporte:hover {
    background-color: #0056b3;
}

/* Layout principal */
.column-right {
    background-color: var(--background-primary);
    padding-top: 0px;
    padding-left: 275px;
    width: 100%;
    min-height: 100vh;
}

.main-container {
    background-color: var(--background-primary);
    padding: 24px;
    margin-top: 10px;
}

.articulo-principal {
    min-height: calc(100vh - 120px);
    max-width: 1200px;
    margin: 0 auto;
}

/* Header de bienvenida */
.welcome-header {
    text-align: center;
    margin-bottom: 32px;
    padding: 24px 0;
}

.welcome-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, var(--primary-light) 0%, var(--secondary-light) 100%);
    border-radius: 50%;
    margin-bottom: 16px;
}

.welcome-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 8px 0;
    letter-spacing: -0.025em;
}

.welcome-subtitle {
    font-size: 1.125rem;
    color: var(--text-secondary);
    margin: 0;
    font-weight: 500;
}

/* Card principal */
.content-card {
    background-color: var(--background-secondary);
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow-lg);
    border: 1px solid var(--border-color);
    overflow: hidden;
}

.card-header {
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
    padding: 32px;
    color: white;
}

.greeting-section {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
}

.greeting-title {
    font-size: 1.875rem;
    font-weight: 700;
    margin: 0 0 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.greeting-emoji {
    font-size: 2rem;
}

.greeting-description {
    font-size: 1.125rem;
    line-height: 1.7;
    margin: 0;
    opacity: 0.95;
    font-weight: 400;
    color: #1e293b;
}

/* Sección de características */
.features-section {
    padding: 40px 32px;
}

.features-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 32px 0;
    text-align: center;
}

.features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 24px;
    max-width: 1000px;
    margin: 0 auto;
}

.feature-card {
    display: flex;
    gap: 16px;
    padding: 24px;
    background-color: var(--background-primary);
    border-radius: var(--radius-lg);
    border: 1px solid var(--border-color);
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
}

.feature-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
    transform: scaleX(0);
    transition: transform 0.3s ease;
}

.feature-card:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
    border-color: var(--primary-color);
}

.feature-card:hover::before {
    transform: scaleX(1);
}

.feature-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
}

.feature-icon.geolocation {
    background: linear-gradient(135deg, #0ea5e9, #0284c7);
}

.feature-icon.calendar {
    background: linear-gradient(135deg, #10b981, #059669);
}

.feature-icon.attention {
    background: linear-gradient(135deg, #8b5cf6, #7c3aed);
}

.feature-icon.management {
    background: linear-gradient(135deg, #f59e0b, #d97706);
}

.feature-icon.analytics {
    background: linear-gradient(135deg, #ef4444, #dc2626);
}

.feature-icon.support {
    background: linear-gradient(135deg, #6366f1, #4f46e5);
}

.feature-content {
    flex: 1;
}

.feature-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 8px 0;
    line-height: 1.4;
}

.feature-description {
    font-size: 0.875rem;
    color: var(--text-secondary);
    line-height: 1.6;
    margin: 0;
}

/* Sección de acciones rápidas */
.quick-actions {
    padding: 32px;
    background-color: var(--background-primary);
    border-top: 1px solid var(--border-color);
}

.actions-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 24px 0;
    text-align: center;
}

.actions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    max-width: 800px;
    margin: 0 auto;
}

.action-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 20px 16px;
    border: none;
    border-radius: var(--radius-lg);
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.action-btn.primary {
    background: linear-gradient(135deg, #0ea5e9, #0284c7);
    color: white;
}

.action-btn.secondary {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
}

.action-btn.tertiary {
    background: linear-gradient(135deg, #8b5cf6, #7c3aed);
    color: white;
}

.action-btn.quaternary {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
}

.action-btn:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
}

.action-icon {
    font-size: 1.5rem;
}

/* Sección footer */
.footer-section {
    background-color: var(--background-primary);
    padding: 32px;
    border-top: 1px solid var(--border-color);
}

.commitment-card {
    max-width: 700px;
    margin: 0 auto;
    display: flex;
    gap: 16px;
    align-items: flex-start;
}

.commitment-icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: var(--secondary-light);
    display: flex;
    align-items: center;
    justify-content: center;
}

.commitment-content {
    flex: 1;
}

.commitment-text {
    font-size: 1rem;
    color: var(--text-secondary);
    line-height: 1.6;
    margin: 0 0 16px 0;
}

.signature {
    margin-top: 16px;
}

.signature-text {
    font-size: 0.875rem;
    color: var(--text-muted);
    margin: 0 0 4px 0;
}

.signature-team {
    font-size: 0.875rem;
    color: var(--text-primary);
    margin: 0;
}

/* Responsive Design */
@media (max-width: 1024px) {

    .features-grid,
    .actions-grid {
        grid-template-columns: 1fr;
    }

    .welcome-title {
        font-size: 2rem;
    }
}

@media (max-width: 1200px) {
    .column-right {
        padding-left: 0px;
    }

    .main-container {
        padding: 16px;
    }

    .welcome-title {
        font-size: 1.75rem;
    }

    .welcome-subtitle {
        font-size: 1rem;
    }

    .card-header {
        padding: 24px 20px;
    }

    .features-section {
        padding: 32px 20px;
    }

    .quick-actions {
        padding: 24px 20px;
    }

    .footer-section {
        padding: 24px 20px;
    }

    .greeting-title {
        font-size: 1.5rem;
        flex-direction: column;
        gap: 4px;
    }

    .greeting-description {
        font-size: 1rem;
    }

    .features-grid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .feature-card {
        padding: 20px;
    }

    .commitment-card {
        flex-direction: column;
        text-align: center;
    }
}

@media (max-width: 480px) {
    .welcome-header {
        padding: 16px 0;
        margin-bottom: 24px;
    }

    .welcome-title {
        font-size: 1.5rem;
    }

    .card-header {
        padding: 20px 16px;
    }

    .features-section {
        padding: 24px 16px;
    }

    .quick-actions {
        padding: 20px 16px;
    }

    .footer-section {
        padding: 20px 16px;
    }

    .feature-card {
        padding: 16px;
        gap: 12px;
    }

    .feature-icon {
        width: 40px;
        height: 40px;
    }

    .greeting-title {
        font-size: 1.25rem;
    }

    .greeting-description {
        font-size: 0.9rem;
    }

    .action-btn {
        padding: 16px 12px;
        font-size: 0.8rem;
    }
}

/* Animaciones suaves */
@media (prefers-reduced-motion: no-preference) {

    .feature-card,
    .commitment-card,
    .action-btn {
        transition: all 0.2s ease;
    }

    .feature-icon {
        transition: transform 0.2s ease;
    }

    .feature-card:hover .feature-icon {
        transform: scale(1.05);
    }
}
</style>